/** The service-health API may return an empty or unparseable timestamp. */
export function formatServiceCheckTime(timestamp: string | null | undefined): string | null {
  if (!timestamp) return null
  const parsed = new Date(timestamp)
  if (Number.isNaN(parsed.getTime())) return null
  return parsed.toLocaleTimeString()
}
